import { Workbook } from "exceljs";
import * as fs from "file-saver";
import _ from "lodash";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";
import { imgFooter, imgRight, logo } from "./imgs";

export class DepartamentDonwnloadExcel {
    constructor() {
        this.months = [
            { name: "Janeiro", c: "C" },
            { name: "Fevereiro", c: "D" },
            { name: "Março", c: "E" },
            { name: "Abril", c: "F" },
            { name: "Maio", c: "G" },
            { name: "Junho", c: "H" },
            { name: "Julho", c: "I" },
            { name: "Agosto", c: "J" },
            { name: "Setembro", c: "K" },
            { name: "Outubro", c: "L" },
            { name: "Novembro", c: "M" },
            { name: "Dezembro", c: "N" }
        ];

        this.sources = {
            fiscal: "Departamento Fiscal",
            pessoal: "Departamento Pessoal",
            financeiro: "Departamento Financeiro"
        };

        this.sourcesSystem = {
            fiscal: "tax",
            pessoal: "personnel",
            financeiro: "fin"
        };
    }

    async export({ data, source, accounting, year }) {
        this.companies = [];

        const workbook = await this.generate({
            data,
            source,
            accounting,
            year
        });

        this.donwload({ year, workbook, source });
    }

    _setCover({ workbook, data, source, accounting }) {
        let worksheetCouver = workbook.addWorksheet("Capa", {
            pageSetup: { paperSize: 9, orientation: "landscape" },
            views: [{ showGridLines: false }]
        });

        worksheetCouver.mergeCells("A1:M4");

        const cellA1 = worksheetCouver.getCell("A1");
        cellA1.font = {
            name: "Arial",
            size: 18,
            bold: true
        };
        cellA1.alignment = { vertical: "middle", horizontal: "center" };
        cellA1.value = accounting.name;

        data.forEach((company, index) => {
            worksheetCouver.mergeCells(`B${index + 6}:H${index + 6}`);
            const cell = worksheetCouver.getCell(`B${index + 6}`);
            cell.font = {
                name: "Arial",
                size: 14,
                outlineLevel: 1,
                underline: true,
                color: { argb: "0000FF" }
            };
            cell.value = {
                text: company.details.nameFixed,
                hyperlink: `#\'${company.details.nameFixed.substring(
                    0,
                    30
                )}\'!A1`
            };
        });

        let mylogoFooter = workbook.addImage({
            base64: imgRight,
            extension: "png"
        });

        worksheetCouver.mergeCells("I5:N42");
        worksheetCouver.addImage(mylogoFooter, "I5:N42");

        let myLogoImage = workbook.addImage({
            base64: imgFooter,
            extension: "png"
        });

        worksheetCouver.mergeCells("A21 :H40");
        worksheetCouver.addImage(myLogoImage, "A31:H40");

        for (let i = 0; i < 200; i++) {
            worksheetCouver.getRow(i + 1).height = 25;
        }
    }

    _setInstructions({ workbook }) {
        let worksheetInstructions = workbook.addWorksheet("Instruções", {
            pageSetup: { orientation: "landscape" },
            views: [{ showGridLines: false }]
        });

        const font = {
            name: "Arial",
            size: 12,
            bold: true
        };

        const alignment = { vertical: "middle", horizontal: "center" };
        const cellB6 = worksheetInstructions.getCell("B8");
        cellB6.font = font;
        // cellB6.alignment = alignment;
        cellB6.value =
            "Essa planilha é para te auxiliar no input de dados do Departamento Financeiro.";

        const cellB8 = worksheetInstructions.getCell("B10");
        cellB8.font = font;
        // cellB8.alignment = alignment;
        cellB8.value =
            "Insira todas as ENTRADAS FINANCEIRAS (como Receita) com o valor POSITIVO";

        const cellB9 = worksheetInstructions.getCell("B11");
        cellB9.font = font;
        // cellB9.alignment = alignment;
        cellB9.value =
            "Insira todas as SAÍDAS FINANCEIRAS (como Despesas) com o valor NEGATIVO";

        let myLogoImage = workbook.addImage({
            base64: logo,
            extension: "png"
        });

        // worksheetInstructions.mergeCells("A1:M4");
        worksheetInstructions.addImage(myLogoImage, "A1:E3");
    }

    async generate({ data, source, accounting, year }) {
        let workbook = new Workbook();

        workbook.creator = "Michael Pascoa";
        workbook.created = new Date();

        this._setCover({ workbook, data, source, accounting });

        if (source == "financeiro")
            this._setInstructions({ workbook, data, source, accounting });

        for (let i = 0; i < data.length; i++) {
            const company = data[i];

            this.companies.push(company.details.name);
            let worksheet = workbook.addWorksheet(
                `${company.details.nameFixed.substring(0, 29)}${i}`,
                {
                    views: [{ showGridLines: true }]
                }
            );

            this._setCellsHeader({
                worksheet,
                company: company.details,
                year,
                source,
                accounting
            });

            this._setCellsColumns({ worksheet });

            for (let i = 0; i < 200; i++) {
                worksheet.getRow(i + 1).height = 21;
            }

            await this.setProtectCells({
                worksheet,
                company: company.details,
                series: company.series
            });

            this._setValuesColumns({
                worksheet,
                series: company.series,
                points: company.points,
                year
            });
        }

        return workbook;
    }

    _setCellsHeader({ company, worksheet, year, source, accounting }) {
        worksheet.mergeCells("A1:A4");

        const cellA1 = worksheet.getCell("A1");

        cellA1.font = {
            name: "Arial",
            size: 14,
            outlineLevel: 1,
            underline: true,
            color: { argb: "0000FF" }
        };
        cellA1.value = {
            text: "Voltar",
            hyperlink: `#\'Capa\'!A1`
        };
        cellA1.alignment = { vertical: "middle", horizontal: "center" };

        worksheet.mergeCells("B1:I4");

        const font = { name: "Arial", size: 12, bold: true };

        worksheet.getColumn("B").width = 25;

        const cellB1 = worksheet.getCell("B1");
        cellB1.value = `${company.name} - ${NormalizeString.formatDocument(
            company.document
        )}`;
        cellB1.font = font;
        cellB1.alignment = { vertical: "middle", horizontal: "center" };

        const cellJ1 = worksheet.getCell("J1");
        cellJ1.value = company._id;
        cellJ1.font = {
            color: { argb: "FFFFFF" }
        };

        const cellK1 = worksheet.getCell("K1");
        cellK1.value = this.sourcesSystem[source];
        cellK1.font = {
            color: { argb: "FFFFFF" }
        };

        const cellL1 = worksheet.getCell("L1");
        cellL1.value = year;
        cellL1.font = {
            color: { argb: "FFFFFF" }
        };

        const cellM1 = worksheet.getCell("M1");
        cellM1.value = "MODELO OFICIAL";
        cellM1.font = {
            color: { argb: "FFFFFF" }
        };

        const cellN1 = worksheet.getCell("N1");
        cellN1.value = accounting._id;
        cellN1.font = {
            color: { argb: "FFFFFF" }
        };

        worksheet.mergeCells("C6:K6");
        const cellC6 = worksheet.getCell("E6");

        cellC6.value = `Dados do ${this.sources[source]} de ${year}`;
        cellC6.font = font;
        cellC6.alignment = { vertical: "middle", horizontal: "center" };
        // const cellA2 = worksheet.getCell("A2");
        // cellA2.value = ``;
        // cellA2.font = font;

        // worksheet.getCell("A3").value = `Ano: ${year}`;
        // worksheet.getCell("A3").font = font;
    }

    _setCellsColumns({ worksheet }) {
        worksheet.getCell("A7").value = "";

        worksheet.getCell("B7").value = "";

        const months = this.months;

        const colunsWidth = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N"
        ];

        colunsWidth.forEach((c) => {
            let value = 20;
            if (["A"].includes(c)) value = 13;
            if (["B"].includes(c)) value = 40;

            worksheet.getColumn(c).width = value;
            ("");
        });

        months.forEach((month) => {
            const font = { name: "Arial", size: 12, bold: true };

            worksheet.getCell(`${month.c}7`).alignment = {
                vertical: "middle",
                horizontal: "center"
            };
            worksheet.getCell(`${month.c}7`).font = font;
            worksheet.getCell(`${month.c}7`).value = month.name;
        });
    }

    _setValuesColumns({ worksheet, series, points, year }) {
        let seriesActive = series.filter((s) => s.metadata.disabled != true);

        seriesActive = seriesActive.map((s, i) => {
            return {
                ...s,
                position: i + 8
            };
        });

        const total = seriesActive.length;

        const font = { name: "Arial", size: 12 };

        for (let serieIndex = 0; serieIndex < total; serieIndex++) {
            const serie = seriesActive[serieIndex];

            if (_.get(serie, "highlight.bold")) {
                const font = { name: "Arial", size: 12, bold: true };
                worksheet.getCell(`A${serieIndex + 8}`).font = font;
                worksheet.getCell(`B${serieIndex + 8}`).font = font;
            } else {
                const font = { name: "Arial", size: 12 };
                worksheet.getCell(`A${serieIndex + 8}`).font = font;
                worksheet.getCell(`B${serieIndex + 8}`).font = font;
            }

            const seriesCompound = seriesActive.filter((s) => {
                if (serie.compound) return serie.compound.includes(s._id);
            });

            const numberFormatsPositve = {
                currency: "R$ #,##0.00",
                int: "0",
                percentage: "0.00",
                number: "0.00",
                days: "0",
                // A planilha volta pela importação: a célula guarda hora DECIMAL (1,50 = 1h30).
                // Sem esta linha, a unidade caía no formato de moeda.
                hours: "0.00"
            };

            const numberFormatsNegative = {
                currency: "-R$ #,##0.00",
                int: "-0",
                percentage: "-0.00",
                number: "-0.00",
                days: "-0",
                hours: "-0.00"
            };

            const isNegative =
                _.get(serie, "metadata.natureOfAccount") == "negative";

            const _formatNumber = (value) => {
                if (value < 0) {
                    return numberFormatsPositve[serie.unit] || "R$ #,##0.00";
                } else if (isNegative) {
                    return numberFormatsPositve[serie.unit] || "-R$ #,##0.00";
                } else {
                    return numberFormatsPositve[serie.unit] || "R$ #,##0.00";
                }
            };

            if (serie.compound && seriesCompound.length) {
                this.months.forEach((month, monthIndex) => {
                    const rowsCompound = seriesCompound.map(
                        (s) => `${month.c}${s.position}`
                    );

                    const value =
                        _.get(
                            points,
                            `${serie._id}.${year}-${monthIndex + 1}`
                        ) || 0;

                    worksheet.getCell(`${month.c}${serieIndex + 8}`).font = {
                        ...font,
                        bold: true
                    };

                    worksheet.getCell(
                        `${month.c}${serieIndex + 8}`
                    ).protection = {
                        locked: true
                    };

                    if (
                        _.get(serie, "metadata.syncAccounting") ||
                        (serie.sources == "personnel" &&
                            _.get(serie, "metadata.sync"))
                    ) {
                        worksheet.getCell(
                            `${month.c}${serieIndex + 8}`
                        ).protection = {
                            locked: true
                        };
                    }

                    worksheet.getCell(`${month.c}${serieIndex + 8}`).value = {
                        formula: rowsCompound.join("+"),
                        result: value
                    };

                    worksheet.getCell(
                        `${month.c}${serieIndex + 8}`
                    ).numFmt = _formatNumber(value);
                });
            } else {
                this.months.forEach((month, monthIndex) => {
                    const value =
                        _.get(
                            points,
                            `${serie._id}.${year}-${monthIndex + 1}`
                        ) || 0;

                    worksheet.getCell(
                        `${month.c}${serieIndex + 8}`
                    ).font = font;

                    worksheet.getCell(
                        `${month.c}${serieIndex + 8}`
                    ).value = value;

                    if (
                        _.get(serie, "metadata.syncAccounting") ||
                        (serie.sources == "personnel" &&
                            _.get(serie, "metadata.sync"))
                    ) {
                        worksheet.getCell(
                            `${month.c}${serieIndex + 8}`
                        ).protection = {
                            locked: true
                        };
                    }

                    worksheet.getCell(`${month.c}${serieIndex + 8}`).numFmt =
                        numberFormatsPositve[serie.unit] || "R$ #,##0.00";

                    worksheet.getCell(
                        `${month.c}${serieIndex + 8}`
                    ).numFmt = _formatNumber(value);

                    if (isNegative) {
                        worksheet.getCell(
                            `${month.c}${serieIndex + 8}`
                        ).dataValidation = {
                            type: "decimal",
                            operator: "between",
                            formulae: [-10000000000000000, 0],
                            allowBlank: true,
                            showErrorMessage: true,
                            showInputMessage: true,
                            promptTitle: "Decimal",
                            errorStyle: "error",
                            // prompt: "Informe um valor negativo",
                            errorTitle: "Informe um valor negativo",
                            error: "Informe um valor negativo"
                        };
                    }
                });
            }

            worksheet.getCell(`A${serieIndex + 8}`).value = serie.classifier;
            worksheet.getCell(`B${serieIndex + 8}`).value = isNegative
                ? `(-) ${serie.name}`
                : serie.name;

            const cellO = worksheet.getCell(`O${serieIndex + 8}`);
            cellO.value = serie._id;
            cellO.font = {
                color: { argb: "FFFFFF" }
            };

            const cellP = worksheet.getCell(`P${serieIndex + 8}`);
            cellP.value = isNegative ? "negative" : "positive";
            cellP.font = {
                color: { argb: "FFFFFF" }
            };
        }
        worksheet.insertRow();
    }

    async setProtectCells({ worksheet, series }) {
        await worksheet.protect("@nucontxxxx", {
            selectUnlockedCells: true,
            formatCells: true,
            formatColumns: true
        });

        const total = series.length + 8;

        // EDITAVEIS
        ["C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"].forEach(
            (column) => {
                for (let i = 8; i < total; i++) {
                    worksheet.getCell(`${column}${i}`).protection = {
                        locked: false
                    };
                }
            }
        );
    }

    donwload({ workbook, source, year }) {
        let fileName = `${this.sources[source]}-${year}.xlsx`;

        if (this.companies.length == 1) {
            fileName = `${this.sources[source]} ${this.companies[0]} ${year}.xlsx`;
        }

        //add data and file name and download
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            fs.saveAs(blob, fileName);
        });

        this.companies = [];
    }
}
